import { useEffect } from 'react';

export default onMount => useEffect(onMount, []);
